import React, { Fragment, useState } from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const CategoryGrid = ({ contentLinks }) => {
  // Level-1 category grid for the auth header; clicks navigate directly, no drilldown.
  return (
    <ul className="flex items-start justify-between gap-2 m-0 p-0 list-none">
      {contentLinks.map((link, index) => (
        <li key={`cat-${index}`} className="flex-1 min-w-0">
          <a
            href={link.url || '#'}
            {...(link.isSelected ? { 'aria-current': 'page' } : {})}
            className="flex flex-col items-center gap-2 text-center text-brand-dark-green hover:opacity-80 transition-opacity"
          >
            <span className="flex items-center justify-center w-[68px] h-[68px] rounded-full bg-brand-turquoise">
              {link.imageUrl && (
                <img src={link.imageUrl} alt="" className="w-9 h-9 object-contain" />
              )}
            </span>
            <span
              className="text-sm font-manrope font-medium leading-tight"
              dangerouslySetInnerHTML={{ __html: link.name }}
            />
          </a>
        </li>
      ))}
    </ul>
  );
};

const Navigation = ({ displayMode = 'legacy' }) => {
  const isStartPage = window.location.pathname === '/';
  const [isVisible, setIsVisible] = useState(isStartPage);
  const contentLinks = useSelector((state) => state.navigation.contentLinks);
  const useDrawer = useSelector((state) => state.navigation.useDrawer);

  if (displayMode === 'category-grid') {
    return <CategoryGrid contentLinks={contentLinks || []} />;
  }

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  return (
    <div className="row">
      {useDrawer ? (
        <Fragment>
          <div className={`navbar__drawer ${isVisible ? 'open' : 'closed'}`}>
            <NavigationItem links={contentLinks} level={1} />
          </div>
          <div className="navbar__button-container navbar__hide-on-mobile">
            <button
              onClick={toggleVisibility}
              className="navbar__button-expand"
            >
              <i
                className={`smdicon-arrow-up ${isVisible ? 'rotate' : ''}`}
              ></i>
              <div
                className={`navbar__divider ${isVisible ? '' : 'closed'}`}
              ></div>
              <span>
                {isVisible
                  ? translate('code.navbar.button.show')
                  : translate('code.navbar.button.hide')}
              </span>
            </button>
          </div>
        </Fragment>
      ) : (
        <NavigationItem links={contentLinks} level={1} />
      )}
    </div>
  );
};

export default Navigation;
